// extracted by mini-css-extract-plugin
module.exports = {"story":"style_story__cgJQr","container":"style_container__FQ92H","content":"style_content__3GeBA","divider":"style_divider__s3NLY","text":"style_text__Z1qNm"};